import { useNavigate } from "react-router-dom";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./EducationHubExplore.module.css";

interface ExploreCard {
	id: string;
	titleKey: string;
	sourcesKey: string;
	image: string;
}

const EXPLORE_CARDS: ExploreCard[] = [
	{
		id: "ivf",
		titleKey: "empty.explore.card1.title",
		sourcesKey: "empty.explore.card1.sources",
		image: "/images/explore-education-1.png",
	},
	{
		id: "mental-health",
		titleKey: "empty.explore.card2.title",
		sourcesKey: "empty.explore.card2.sources",
		image: "/images/explore-education-2.png",
	},
	{
		id: "nutrition",
		titleKey: "empty.explore.card3.title",
		sourcesKey: "empty.explore.card3.sources",
		image: "/images/explore-education-1.png",
	},
	{
		id: "hormones",
		titleKey: "empty.explore.card4.title",
		sourcesKey: "empty.explore.card4.sources",
		image: "/images/explore-education-2.png",
	},
];

interface EducationHubExploreProps {
	backgroundColor?: string;
	headingColor?: string;
	dotsColor?: string;
}

export function EducationHubExplore({
	backgroundColor = "#FFF2FC",
	headingColor,
	dotsColor,
}: EducationHubExploreProps) {
	const { t, direction } = useClientTranslations("getReady");
	const navigate = useNavigate();

	return (
		<div
			className={styles.container}
			style={{
				backgroundColor,
				...(dotsColor
					? ({ "--dots-active-color": dotsColor } as React.CSSProperties)
					: {}),
			}}
		>
			<h3
				className={styles.heading}
				style={headingColor ? { color: headingColor } : undefined}
			>
				{t("empty.explore.heading")}
			</h3>
			<p className={styles.subtitle}>{t("empty.explore.subtitle")}</p>

			<div className={styles.carouselWrapper}>
				<Swiper
					modules={[Pagination]}
					slidesPerView="auto"
					spaceBetween={11}
					pagination={{ clickable: true }}
					dir={direction}
					threshold={10}
					touchStartPreventDefault={false}
					resistanceRatio={0.65}
					className={styles.swiper}
				>
					{EXPLORE_CARDS.map((card) => (
						<SwiperSlide key={card.id} className={styles.slide}>
							<button
								type="button"
								className={styles.card}
								onClick={() => navigate("/education")}
							>
								<img
									src={card.image}
									alt={t(card.titleKey)}
									className={styles.cardImage}
								/>
								<div className={styles.cardContent}>
									<span className={styles.cardTitle}>{t(card.titleKey)}</span>
									<span className={styles.cardSources}>
										{t(card.sourcesKey)}
									</span>
								</div>
							</button>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
}
